import { createContext, Dispatch, SetStateAction } from "react";

/**
 * Holds which save guards are enabled.
 */
const SaveGuardEnabledIdsContext = createContext<
  [Set<string>, Dispatch<SetStateAction<Set<string>>>]
>([
  new Set(),
  () => {
    throw new Error("SaveGuardEnabledIdsContext is not provided");
  },
]);

export default SaveGuardEnabledIdsContext;
